export * from './anz-page-url-segment.type';

export enum EnrollmentFormType {
  CreditCardAndBankAccount, // ANZ Consumer
  NoCreditCardOnlyBankAccount, // ANZ Consumer
  CreditCardOnly, // ANZ Biz
  NoCreditCard, // ANZ Biz
}
